(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veloura-carrusel"] && !Shopify.designMode) return;
  try {
    
  // Un solo bloque para TODOS los carruseles de la pagina: {% javascript %} lo
  // emite una vez por theme, asi que el script recorre los .vcar en vez de
  // colgarse de un id de seccion.
  (function () {
    function iniciar(raiz) {
      if (raiz.dataset.vcarListo) return;
      var riel = raiz.querySelector('[data-vcar-riel]');
      if (!riel) return;
      raiz.dataset.vcarListo = '1';

      var cajaFlechas = raiz.querySelector('[data-vcar-flechas]');
      var prev = raiz.querySelector('[data-vcar-prev]');
      var next = raiz.querySelector('[data-vcar-next]');

      function paso() {
        var item = riel.firstElementChild;
        if (!item) return riel.clientWidth;
        var estilo = window.getComputedStyle(riel);
        var gap = parseFloat(estilo.columnGap || estilo.gap || '0') || 0;
        return item.getBoundingClientRect().width + gap;
      }

      function sincronizar() {
        var desborda = riel.scrollWidth - riel.clientWidth > 2;
        if (cajaFlechas) cajaFlechas.hidden = !desborda;
        if (!desborda) return;
        var x = riel.scrollLeft;
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= riel.scrollWidth - riel.clientWidth - 2;
      }

      if (prev) prev.addEventListener('click', function () { riel.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { riel.scrollBy({ left: paso(), behavior: 'smooth' }); });

      riel.addEventListener('scroll', sincronizar, { passive: true });
      window.addEventListener('resize', sincronizar);
      if ('ResizeObserver' in window) new ResizeObserver(sincronizar).observe(riel);
      // Las imagenes son lazy: hasta que no cargan, scrollWidth miente.
      riel.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', sincronizar, { once: true });
      });
      sincronizar();

      // Arrastre con el mouse. En tactil no se toca: ahi el scroll nativo ya
      // funciona y engancharse encima solo rompe el gesto.
      var abajo = false, x0 = 0, s0 = 0, movido = 0;
      riel.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        abajo = true; movido = 0;
        x0 = e.clientX; s0 = riel.scrollLeft;
      });
      riel.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var d = e.clientX - x0;
        if (Math.abs(d) > 4) {
          riel.setAttribute('data-arrastrando', '');
          riel.setPointerCapture(e.pointerId);
        }
        movido = Math.max(movido, Math.abs(d));
        riel.scrollLeft = s0 - d;
      });
      function soltar(e) {
        if (!abajo) return;
        abajo = false;
        riel.removeAttribute('data-arrastrando');
        if (e && riel.hasPointerCapture && riel.hasPointerCapture(e.pointerId)) riel.releasePointerCapture(e.pointerId);
        sincronizar();
      }
      riel.addEventListener('pointerup', soltar);
      riel.addEventListener('pointercancel', soltar);
      riel.addEventListener('pointerleave', soltar);
      // Si se arrastro, el click que sigue no debe abrir el producto.
      riel.addEventListener('click', function (e) {
        if (movido > 6) { e.preventDefault(); e.stopPropagation(); movido = 0; }
      }, true);
    }

    function barrer() { document.querySelectorAll('.vcar').forEach(iniciar); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', barrer);
    } else {
      barrer();
    }
    // El editor de temas re-inserta la seccion al editarla.
    document.addEventListener('shopify:section:load', barrer);
  })();

  } catch(e) { console.error(e); }
})();
})();
